var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { checkDevice, ttfb } from "@total_onion/onion-utils";
import reservebarPopup from "Assets/js/modules/library-modules/reservebar-popup/reservebar-popup";
import { modalPopup } from "Assets/js/modules/modal-popup";
import topicTreeJs from "Assets/js/modules/topic-tree";
import campusUtilityPanel from "Assets/js/modules/campus-utility-panel";
import lazyloaderV3 from "@total_onion/onion-library/onion-loader";
import jsAssets from "Assets/js/modules/jsAssets.js";
let runLazyLoadv3 = () => {
    lazyloaderV3.options.projectAssets = jsAssets.dynamicAssets;
    lazyloaderV3.options.debugLogMessages = false;
    lazyloaderV3.lazyloaderInit();
};
function yieldToMain() {
    return new Promise((resolve) => {
        setTimeout(resolve, 0);
    });
}
window.addEventListener("DOMContentLoaded", () => {
    function runSiteJs() {
        return __awaiter(this, void 0, void 0, function* () {
            const tasks = [
                ttfb,
                checkDevice,
                topicTreeJs,
                reservebarPopup,
                modalPopup,
                campusUtilityPanel,
                runLazyLoadv3,
            ];
            while (tasks.length > 0) {
                const task = tasks.shift();
                task();
                yield yieldToMain();
            }
        });
    }
    runSiteJs();
});
